export enum MbiemriRasa {
  Emerore = 10,
  Gjinore = 11,
  Dhanore = 12,
  Kallezore = 13,
  Rrjedhore = 14,
  // Vendore = 15,
  // Thirrore = 16,
}

export enum MbiemriNumri {
  Njejes = 10,
  Shumes = 11,
  Vetemnenjejes = 12,
  Vetemneshumes = 13,
  Kryesishtnenjejes = 14,
  Kryesishtneshumes = 15,
}

export enum MbiemriLloji {
  Inyjshem = 10,
  Ipanyjshem = 11
}

export enum MbiemriTrajta {
  Eshquar = 10,
  Epashquar = 11,
}

export enum MbiemriGjinia {
  Mashkullore = 10,
  Femerore = 11,
  Asnjanese = 12,
}

export enum MbiemriRenditja {
  EmerMbiemer = 10,
  MbiemerEmer = 11
}

export enum MbiemriFormaFjales {
  cc = 10
}

export enum MbiemriLlojiTemaShumesit {
  ShumeesiMeNdryshimNyje = 10, //shumësi me ndryshim nyje
  ShumeesiMeNdryshimNyjenje = 11, //shumësi me ndryshim nyje 1
  ShumeesiMeNdryshimNyjenj = 12, //shumësi me ndryshim nyje + nj
  ShumeesiMeNdryshimNyjeeeeinj = 13, //shumësi me ndryshim nyje +e>ë + inj
  NdryshimNyjeggj = 14, //ndryshim nyje +g>gj
  ShumeesiMeNdryshimNyjeoeggj = 15, //shumësi me ndryshim nyje + o>e +g>gj
  ShumeesiMeNdryshimNyjeaeeenj = 16, //shumësi me ndryshim nyje +a>ë + enj
  MbiemeerMeTemeeMeeSheem = 17, //mbiemër me temë më-shëm
  MbiemeerMeTemeeMeeeem = 18, //mbiemër me temë më-ëm
  MbiemeerMeTemeeMeeeel = 19, //mbiemër me temë më-ël
  MbiemeerMeTemeeMeeMee = 20, //mbiemër me temë më -më
  ShumeesiMeMbareseenee = 21, //shumësi me  mbaresën -ë
  ShumeesiMeSiNjeenjeesi = 22, //shumësi me si njëjësi
  ShumeesiMeMbareseennj = 23, //shumësi me mbaresën -nj
  ShumeesiSiEmratMashkullorDheFemerorKonversion = 24, //shumësi  si emrat mashkullorë dhe femërorë (konversion)
  ShumeesiSiPjesaIIEMbiemritSiMbiemri = 25, //shumësi si pjesa II e mbiemrit  (si mbiemri)
  PjesaIIEmeerMashkullorKompoziteeMePjeseeIIEmeerMashkullor = 26, //pjesa II emër mashkullor (kompozitë me pjesë II emër mashkullor)
  ShumeesiSiPjesaIIEMbiemritKompoziteeMePjeseeIINjeeEmeerFemeeroreeOseLeende = 27, //shumësi si pjesa II e mbiemrit (kompozitë me pjesë II një emër femëror ose lënde)
  ShumeesiMeMbareseeneeu = 28, //Shumësi me mbaresën -ë (u)
  ShumeesiParaDhePasNdryshe = 29, //Shumësi para dhe pas ndryshe
  MbiemeerINgurtee = 30 // Mbiemër i ngurtë
}

export enum MbiemriLloji10TemaShumesit {
  ShumeesiMeNdryshimNyje = 10, //shumësi me ndryshim nyje
  ShumeesiMeNdryshimNyjenje = 11, //shumësi me ndryshim nyje 1
  ShumeesiMeNdryshimNyjenj = 12, //shumësi me ndryshim nyje + nj
  ShumeesiMeNdryshimNyjeeeeinj = 13, //shumësi me ndryshim nyje +e>ë + inj
  NdryshimNyjeggj = 14, //ndryshim nyje +g>gj
  ShumeesiMeNdryshimNyjeoeggj = 15, //shumësi me ndryshim nyje + o>e +g>gj
  ShumeesiMeNdryshimNyjeaeeenj = 16, //shumësi me ndryshim nyje +a>ë + enj
  MbiemeerMeTemeeMeeSheem = 17, //mbiemër me temë më-shëm
  MbiemeerMeTemeeMeeeem = 18, //mbiemër me temë më-ëm
  MbiemeerMeTemeeMeeeel = 19, //mbiemër me temë më-ël
  MbiemeerMeTemeeMeeMee = 20, //mbiemër me temë më -më
}


export enum MbiemriLloji11TemaShumesit {
  ShumeesiMeMbareseenee = 10, //shumësi me  mbaresën -ë
  ShumeesiMeSiNjeenjeesi = 11, //shumësi me si njëjësi
  ShumeesiMeMbareseennj = 12, //shumësi me mbaresën -nj
  ShumeesiSiEmratMashkullorDheFemerorKonversion = 13, //shumësi  si emrat mashkullorë dhe femërorë (konversion)
  ShumeesiSiPjesaIIEMbiemritSiMbiemri = 14, //shumësi si pjesa II e mbiemrit  (si mbiemri)
  PjesaIIEmeerMashkullorKompoziteeMePjeseeIIEmeerMashkullor = 15, //pjesa II emër mashkullor (kompozitë me pjesë II emër mashkullor)
  ShumeesiSiPjesaIIEMbiemritKompoziteeMePjeseeIINjeeEmeerFemeeroreeOseLeende = 16, //shumësi si pjesa II e mbiemrit (kompozitë me pjesë II një emër femëror ose lënde)
  ShumeesiMeMbareseeneeu = 28, //Shumësi me mbaresën -ë (u)
  ShumeesiParaDhePasNdryshe = 29, //Shumësi para dhe pas ndryshe
  MbiemeerINgurtee = 30 // Mbiemër i ngurtë
}
